module.exports = __webpack_public_path__ + "img/head-banner.3bb45cce.jpg";